/**
 * The team-access agent, full-screen at its own subdomain.
 *
 * Providers, auth gate, login bounce, i18n, async-turn delivery and the route
 * table are the platform's AgentApp — one implementation for every agent, so
 * the wiring cannot drift app by app (it already had: five apps were not
 * following the signed-in user's language, six never mounted the session-event
 * subscriber their chat needs). What is this agent's own is what it passes.
 */
import { lazy } from 'react'
import { AgentApp } from '@frontend/components/agentDetail/AgentApp'

import TeamAccessHome from './pages/TeamAccessHome'
import Session from './pages/Session'

// DEV-only render harness (/preview) — the real surface over fixture data, no
// auth/backend. import.meta.env.DEV is statically false in production builds,
// so this lazy chunk is dead-code-eliminated there.
const Preview = lazy(() => import('./pages/Preview'))

export default function App() {
  return <AgentApp home={<TeamAccessHome />} sessionScreen={<Session />} devPreview={Preview} />
}
